export default __webpack_public_path__ + "static/babylon-thumbnail-1885e05b87351d443a4a004f715c2cb7.webp";